import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "../motion/Reveal";
import { INSIGHTS, IMAGES } from "../../data/content";

const covers = [IMAGES.lamboClub, IMAGES.stadium, IMAGES.detailFerrari];

export const Insights = () => {
  return (
    <section id="insights" className="relative py-24 md:py-36 bg-ink-soft/40 border-y border-white/10">
      <div className="container-editorial">
        <div className="grid lg:grid-cols-12 gap-8 items-end mb-16">
          <div className="lg:col-span-8">
            <Reveal>
              <p className="overline mb-6">06 — Insights</p>
              <h2 className="font-serif text-4xl md:text-6xl leading-[1.02] tracking-tight text-bone">
                Thoughts, Knowledge <br /> and <span className="italic text-gold">Perspective.</span>
              </h2>
            </Reveal>
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {INSIGHTS.map((a, i) => (
            <Reveal key={a.title} delay={i * 0.1}>
              <motion.a
                data-testid={`insight-card-${i}`}
                href={a.href}
                whileHover={{ y: -8 }}
                transition={{ type: "spring", stiffness: 200, damping: 20 }}
                className="group flex flex-col h-full edit-card"
              >
                {/* cover */}
                <div className="relative h-52 overflow-hidden border-b border-white/10">
                  {covers[i] ? (
                    <img
                      src={covers[i]}
                      alt=""
                      className="h-full w-full object-cover contrast-[1.05] saturate-[1.08] transition-transform duration-700 group-hover:scale-110"
                      loading="lazy"
                    />
                  ) : (
                    <div className="h-full w-full bg-gradient-to-br from-ink-soft to-ink flex items-center justify-center">
                      <span className="font-serif text-7xl text-white/5">{String(i + 1).padStart(2, "0")}</span>
                    </div>
                  )}
                  <span className="absolute top-4 left-4 overline bg-ink/70 backdrop-blur px-3 py-1">
                    {a.category}
                  </span>
                </div>

                <div className="flex flex-col flex-1 p-7">
                  <h3 className="font-serif text-2xl text-bone leading-snug tracking-tight group-hover:text-gold transition-colors duration-300">
                    {a.title}
                  </h3>
                  <p className="mt-3 text-ash leading-relaxed flex-1">{a.description}</p>
                  <div className="mt-6 flex items-center justify-between pt-5 border-t border-white/10">
                    <span className="font-mono text-xs text-ash">{a.readingTime}</span>
                    <span className="inline-flex items-center gap-1.5 text-sm text-bone group-hover:text-gold transition-colors">
                      Read Insight <ArrowUpRight size={15} className="transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                    </span>
                  </div>
                </div>
              </motion.a>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
